import { type FC } from 'react';

import { AscendingIcon, DescendingIcon } from '../../../icons';
import { type SortDirection } from '../types';

interface Props {
  direction: SortDirection;
}

const SortDirectionIndicator: FC<Props> = ({ direction }: Props) => {
  return direction === 'asc' ? (
    <AscendingIcon data-testid="sort-asc-icon" className="size-4" />
  ) : (
    <DescendingIcon data-testid="sort-desc-icon" className="size-4" />
  );
};

export default SortDirectionIndicator;
